import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { UserAssignmentFilterPipe } from './user-assignment-filter.pipe';
import { ItemReminderSummaryPipe } from './compliance-reminder-summary.pipe';
import { PropertyFilterPipe } from './property-filter.pipe';
import { UserPermissionPipe } from './user-permission/user-permission.pipe';
import { ItemSubtypePipe } from './item-subtype/item-subtype.pipe';
@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PropertyFilterPipe,
        UserAssignmentFilterPipe,
        ItemReminderSummaryPipe,
        UserPermissionPipe,
        ItemSubtypePipe
    ],
    exports: [
        PropertyFilterPipe,
        UserAssignmentFilterPipe,
        ItemReminderSummaryPipe,
        UserPermissionPipe,
        ItemSubtypePipe
    ]
})
export class PipesModule {}